var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 87,
    viewBox: "0 0 91 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M91 43.5C91 47.9821 82.47 51.0558 81.1592 55.1005C79.8485 59.1452 84.847 66.7892 82.3097 70.2762C79.7723 73.7632 71.0499 71.2954 67.5305 73.8595C64.0111 76.4235 63.7505 85.468 59.5617 86.8283C55.3728 88.1885 49.9734 81.022 45.5 81.022C41.0266 81.022 35.4748 88.1404 31.4383 86.8283C27.4018 85.5161 26.9569 76.3995 23.4695 73.8595C19.9822 71.3195 11.2517 73.7993 8.69034 70.2762C6.12893 66.7531 11.2036 59.2896 9.84477 55.1005C8.4859 50.9113 0 47.9821 0 43.5C0 39.0179 8.53 35.9442 9.84076 31.8995C11.1515 27.8548 6.15298 20.2108 8.69034 16.7238C11.2277 13.2368 19.9501 15.7046 23.4695 13.1405C26.9889 10.5765 27.2495 1.53203 31.4383 0.17175C35.6272 -1.18853 41.0266 5.97801 45.5 5.97801C49.9734 5.97801 55.5252 -1.14038 59.5617 0.17175C63.5982 1.48388 64.0431 10.6005 67.5305 13.1405C71.0178 15.6805 79.7483 13.2007 82.3097 16.7238C84.8711 20.2469 79.7964 27.7103 81.1552 31.8995C82.5141 36.0887 90.996 39.0179 90.996 43.5H91Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.69615cc82612d9a608e51807ec2a7cb6.svg";
export { ForwardRef as ReactComponent };